export default "__VITE_ASSET__060a8134__"